export default __webpack_public_path__ + "static/media/information--lodging--g2.22045613.png";